import { render, staticRenderFns } from "./PreferencesComponent.vue?vue&type=template&id=636e5c51&scoped=true"
import script from "./PreferencesComponent.vue?vue&type=script&lang=js"
export * from "./PreferencesComponent.vue?vue&type=script&lang=js"
import style0 from "./PreferencesComponent.vue?vue&type=style&index=0&id=636e5c51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e5c51",
  null
  
)

export default component.exports